// 供销商名称
import { querySupplierPageList } from "@api/supplier";

const supplierNames = {
  state: () => ({
    nameList: [], // 供销商列表
  }),
  mutations: {
    setNameList(state, nameList) {
      state.nameList = nameList;
    },
  },
  actions: {
    queryNameList({ commit, state }) {
      if (state.nameList.length) return console.log("已加载过供销商名称");
      querySupplierPageList({
        pageNo: 1,
        pageSize: 999,
      })
        .then((res) => {
          commit("setNameList", res.data.list);
        })
        .catch((err) => console.log("actions-queryList-error!###", err));
    },
  },
  getters: {
    supplierNameMap(state) {
      const nameListMap = {};
      state.nameList.forEach((item) => {
        nameListMap[item.supplierCompanyId] = item.supplierCompanyName;
      });
      return nameListMap;
    },
    supplierNameList(state) {
      return state.nameList.map((item) => {
        return {
          label: item.supplierCompanyName,
          value: item.supplierCompanyId,
        };
      });
    },
  },
};

export default supplierNames;
